import { useState } from "react";
import { toast } from "sonner";
import axios from "../axios";

export const useGetCampaignCategory = () => {
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);

  const getCampaignCategories = async (token) => {
    setLoading(true);
    try {
      const res = await axios.get(`/audiences/campaign-category`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.status === 201) {
        setLoading(false);
        setCategories(res?.data?.data);
      }
    } catch (err) {
      setLoading(false);
      toast.error(err?.response?.data?.message);
    }
  };

  return {
    getCampaignCategories,
    categories,
    setCategories,
    loading,
    setLoading,
  };
};
